module.exports = __webpack_public_path__ + "static/media/fruit.ed1b2446.png";